export default "__VITE_ASSET__2HvvHRNL__"